import { Content } from "../common/FormConfirm";

export default Content;
